import * as z from "zod";

export const NotificationAlertDtoSchema = z
    .object({
        id: z.number(),
        title: z.string().trim(),
        body: z.string().trim(),
        read: z.boolean(),
        created_at: z.string().trim(),
    })
    .readonly();

export type NotificationAlertDto = z.output<typeof NotificationAlertDtoSchema>;

export const NotificationAlertsDtoSchema = z
    .array(NotificationAlertDtoSchema)
    .readonly();

export type NotificationAlertsDto = z.output<
    typeof NotificationAlertsDtoSchema
>;

export interface NotificationAlertUpdateBody {
    read: boolean;
}
